export default __webpack_public_path__ + "static/media/M.b8626149.svg";